export const formatContentTitle = (title?: string) => {
  return title?.split('‎ ')[1] ?? title
}
